module.exports = __webpack_public_path__ + "img/astro_logo.0e14452.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/astro_logo.png
// module id = TM+H
// module chunks = 1